import styled from 'styled-components';
import {
  contentPadding,
  fillHeightAndScrollable,
  page,
  verticalLayout,
} from '../../../styles/layout';
import { header4 } from '../../../styles/text';
import { Main } from '../../Main';

export const Page = styled.div`
  ${verticalLayout}
  ${page}
`;

export const Content = styled(Main)`
  ${fillHeightAndScrollable}
  ${contentPadding}
`;

export const Title = styled.h2`
  ${header4}
`;

export const SectionHeader = Title;

export const SectionContainer = styled.div`
  padding-bottom: 1rem;
`;
